export default __webpack_public_path__ + "static/overpass-bold-cacea1c3dd5e0ef67e8895f05e95259a.woff";